Object.defineProperty(exports, '__esModule', { value: true });

var en = {
  code: 'en',
  week: {
    dow: 0,
    doy: 4
  },
  direction: 'ltr',
  buttonText: {
    prev: 'Prev',
    next: 'Next',
    prevYear: 'Prev year',
    nextYear: 'Next year',
    year: 'Year',
    today: 'Today',
    month: 'Month',
    week: 'Week',
    day: 'Day',
    list: 'List'
  },
  weekText: 'W',
  allDayText: 'All-day',
  moreLinkText: 'More',
  noEventsText: 'No events to display'
};

exports.default = en;
